module.exports = __webpack_public_path__ + "img/1_si.23d33386.jpg";